// extracted by mini-css-extract-plugin
export default {"legal_header":"legal_header___mg1gK"};